const Marionette = require('backbone.marionette');
const templates = require('../templates');
const moment = require('moment');

module.exports = Marionette.ItemView.extend({
  template: templates.header_hour,
  serializeData() {
    return {
      currentHour: moment(this.model.get('currentDate')).format('HH[H]mm')
    };
  },
  modelEvents: {
    'change:currentDate': 'render'
  }
});



// WEBPACK FOOTER //
// ./src/views/header_hour.js